/**
 * 首页公开统计徽章 — 信任卡片
 * 拉 /api/site,显示:
 *   - 主行:全量数字(信任感)  127 位用户 / 432 次查询 / 18 份报告
 *   - 副行:近 24h / 7d 数字(新鲜感) ● 近 24h 12 次搜索 / 近 7d 3 份报告
 * 公开(无鉴权),失败不阻塞
 */
import { useEffect, useState } from 'react'
import { getSiteStats, ApiError, type SiteStats } from '../lib/api'

const ZERO: SiteStats = {
  total_users: 0, total_events: 0,
  total_searches: 0, total_school_views: 0, total_major_views: 0, total_reports: 0,
  last_24h_searches: 0, last_7d_reports: 0,
}

export default function SiteStatsBadge() {
  const [s, setS] = useState<SiteStats>(ZERO)
  useEffect(() => {
    getSiteStats()
      .then(r => setS(r))
      .catch(() => { /* 静默失败,保持 0 */ })
  }, [])

  const totals: Array<{ v: number; l: string }> = [
    { v: s.total_users, l: '位用户' },
    { v: s.total_searches, l: '次查询' },
    { v: s.total_school_views, l: '次学校详情' },
    { v: s.total_reports, l: '份志愿报告' },
  ]
  const grandTotal = totals.reduce((a, b) => a + b.v, 0)
  const hasRecent = s.last_24h_searches > 0 || s.last_7d_reports > 0

  return (
    <div
      className="card"
      style={{
        maxWidth: 600,
        margin: '1.5rem auto 0',
        padding: '.75rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '.375rem',
      }}
    >
      {/* 主行:全量 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <span className="module-badge" style={{ marginRight: 0 }}>Σ</span>
        <span style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink3)', letterSpacing: '.05em' }}>已有</span>
        {totals.map((it, i) => (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'baseline', gap: '.25rem' }}>
            <span className="mono" style={{ fontWeight: 600, color: 'var(--ink2)', fontSize: 'var(--fs-body)' }}>{fmt(it.v)}</span>
            <span style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink3)' }}>{it.l}</span>
          </span>
        ))}
        {grandTotal === 0 && (
          <span style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink3)' }}>本站刚上线,数据待积累</span>
        )}
      </div>
      {/* 副行:近 N 天,有数据才显示 */}
      {hasRecent && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', flexWrap: 'wrap', justifyContent: 'center', fontSize: 'var(--fs-capt)' }}>
          <span className="dot-live" style={{ width: 5, height: 5 }} />
          <span style={{ color: 'var(--ink3)' }}>近 24h</span>
          <span className="mono" style={{ color: 'var(--brand)', fontWeight: 600 }}>{s.last_24h_searches}</span>
          <span style={{ color: 'var(--ink3)' }}>次搜索</span>
          <span style={{ color: 'var(--rule)' }}>·</span>
          <span style={{ color: 'var(--ink3)' }}>近 7d</span>
          <span className="mono" style={{ color: 'var(--brand)', fontWeight: 600 }}>{s.last_7d_reports}</span>
          <span style={{ color: 'var(--ink3)' }}>份报告</span>
        </div>
      )}
    </div>
  )
}

function fmt(n: number): string {
  return n.toLocaleString('en-US')
}
